<template>
<ItpSelect2
  v-model="internalValue"
  :name="name"
  valueField="id"
  textField="description"
  :filterable="b_7315092382398562_filterable"
  :searchable="b_7315092382398562_searchable"
  :options="items"
  :readonly="readonly"
  @input="evh_7315092382398562_input($event, {})"
>
  <template
    slot="list-footer"
  >
    <HR>
    </HR>
    <ItpLink
      :text="'Add new...'|gettext"
      class="dropdown-item"
      @click="evh_3343864469950044_click($event, {})"
    >
    </ItpLink>
  </template>
</ItpSelect2>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class NumberingSelector extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: String,
  })
  objectType!: string;

  @Watch('objectType')
  onObject_type(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("objectType")
  }

  @Prop({
    type: String,
  })
  name!: string;

  @Watch('name')
  onName(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("name")
  }

  @Prop({
    required: true,
  })
  value!: any;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  @Prop({
    type: Boolean,
    default: false,
  })
  bindObject!: boolean;

  @Watch('bindObject')
  onBind_object(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("bindObject")
  }

  internalValue!: any;

  async $$load_internalValue() {
    return this.bindObject ? (this.value ? this.value.id : null) : this.value
  }

  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_numbering', { parameters: { resource_type: this.objectType } })
      .then(
        d => [{ id: null, description: this.$fn.gettext('Manual') }].concat(d)
      )
  }

  ux!: any;
  b_7315092382398562_filterable!: any;
  b_7315092382398562_searchable!: any;
  dataMembers = ['internalValue', 'items', 'ux', 'b_7315092382398562_filterable', 'b_7315092382398562_searchable'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        internalValue: null,
        items: null,
        ux: null,
        b_7315092382398562_filterable: false,
        b_7315092382398562_searchable: false,
      },
    }
  }

  async act_7315092382398562_emit_3692_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7315092382398562_emit_3692, alias=undefined
    return {
      event: "input",
      value: this.bindObject ? { id: $event.originalEvent } : $event.originalEvent,
    }
  }

  async evh_7315092382398562_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_input.executeFromDOM(this, event, scope);
  }

  async act_3343864469950044_register_3696_getActionArgs($event: actions.ActionEvent): Promise<actions.RegisterActionArgs> {
    // parameterResolver name=act_3343864469950044_register_3696, alias=undefined
    return {
      name: "resultID",
      value: $event.data.modalResult && $event.data.modalResult.ok && $event.data.modalResult.value.id,
    }
  }

  async evh_3343864469950044_close_3697_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_3343864469950044_close_3697, alias=undefined
    return $event.data.resultID
  }

  async act_3343864469950044_setData_3700_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_3343864469950044_setData_3700, alias=undefined
    return {
      path: "internalValue",
      value: this.resultID,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_3343864469950044_close_3699_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_3343864469950044_close_3699, alias=undefined
    return $event.data.resultID
  }

  async act_3343864469950044_showModal_3694_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_3343864469950044_showModal_3694, alias=undefined
    return {
      name: "Numbering",
      props: {
        objectType: this.objectType,
      }
      ,
    }
  }

  async evh_3343864469950044_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3343864469950044_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_emit_3692: actions.EmitAction;
    evh_7315092382398562_input_3691: actions.EventHandlerImpl;
    evh_7315092382398562_input: actions.EventHandlerGroup;
    act_3343864469950044_register_3696: actions.RegisterAction;
    evh_3343864469950044_close_3695: actions.EventHandlerImpl;
    act_3343864469950044_reloadComponentData_3698: actions.ReloadComponentDataAction;
    evh_3343864469950044_close_3697: actions.EventHandlerImpl;
    act_3343864469950044_setData_3700: actions.SetDataAction;
    evh_3343864469950044_close_3699: actions.EventHandlerImpl;
    act_3343864469950044_showModal_3694: actions.ShowModalAction;
    evh_3343864469950044_click_3693: actions.EventHandlerImpl;
    evh_3343864469950044_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_emit_3692 = new actions.EmitAction(
      {
        actionArgs: this.act_7315092382398562_emit_3692_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_input_3691 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_emit_3692,
        event: "input",
        displayName: "emit",
      }
    );
    const evh_7315092382398562_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_input_3691],
      }
    );
    const act_3343864469950044_register_3696 = new actions.RegisterAction(
      {
        actionArgs: this.act_3343864469950044_register_3696_getActionArgs,
        events: [],
      }
    );
    const evh_3343864469950044_close_3695 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_register_3696,
        event: "close",
        displayName: "register",
      }
    );
    const act_3343864469950044_reloadComponentData_3698 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_3343864469950044_close_3697 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_reloadComponentData_3698,
        event: "close",
        when: this.evh_3343864469950044_close_3697_getWhen,
        displayName: "reloadComponentData",
      }
    );
    const act_3343864469950044_setData_3700 = new actions.SetDataAction(
      {
        actionArgs: this.act_3343864469950044_setData_3700_getActionArgs,
        events: [],
      }
    );
    const evh_3343864469950044_close_3699 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_setData_3700,
        event: "close",
        when: this.evh_3343864469950044_close_3699_getWhen,
        displayName: "setData",
      }
    );
    const act_3343864469950044_showModal_3694 = new actions.ShowModalAction(
      {
        actionArgs: this.act_3343864469950044_showModal_3694_getActionArgs,
        events: [evh_3343864469950044_close_3695, evh_3343864469950044_close_3697, evh_3343864469950044_close_3699],
      }
    );
    const evh_3343864469950044_click_3693 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_showModal_3694,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_3343864469950044_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_3343864469950044_click_3693],
      }
    );
    return {
      act_7315092382398562_emit_3692,
      evh_7315092382398562_input_3691,
      evh_7315092382398562_input,
      act_3343864469950044_register_3696,
      evh_3343864469950044_close_3695,
      act_3343864469950044_reloadComponentData_3698,
      evh_3343864469950044_close_3697,
      act_3343864469950044_setData_3700,
      evh_3343864469950044_close_3699,
      act_3343864469950044_showModal_3694,
      evh_3343864469950044_click_3693,
      evh_3343864469950044_click,
    }
  }
}

Vue.component("NumberingSelector", NumberingSelector);

</script>